export const ARTICLE_TEMPLATE = {
  SHOPS: "shops",
  SPOTS: "spots",
  NORMAL: "normal",
  MEMORY: "memory",
};

export const categories = [
  {
    key: "hotel",
    label: { JP: "ホテル", EN: "Hotel", 中文: "酒店", 한국어: "호텔" },
    icon: "🏨",
    path: "/blog/category/hotel",
  },
  {
    key: "cafe",
    label: { JP: "カフェ", EN: "Cafe", 中文: "咖啡馆", 한국어: "카페" },
    icon: "☕",
    path: "/blog/category/cafe",
  },
  {
    key: "beach",
    label: { JP: "ビーチ", EN: "Beach", 中文: "海滩", 한국어: "해변" },
    icon: "🌴",
    path: "/blog/category/beach",
  },
  {
    key: "rainy",
    label: {
      JP: "雨の日",
      EN: "Rainy Day",
      中文: "雨天",
      한국어: "비 오는 날",
    },
    icon: "☂️",
    path: "/blog/category/rainy",
  },
  {
    key: "sunset",
    label: { JP: "サンセット", EN: "Sunset", 中文: "夕阳", 한국어: "선셋" },
    icon: "🌅",
    path: "/blog/category/sunset",
  },
  {
    key: "spot",
    label: {
      JP: "映えスポット",
      EN: "Photo Spots",
      中文: "拍照景点",
      한국어: "사진 스팟",
    },
    icon: "📷",
    path: "/blog/category/spot",
  },
  {
    key: "drive",
    label: { JP: "ドライブ", EN: "Drive", 中文: "自驾", 한국어: "드라이브" },
    icon: "🚙",
    path: "/blog/category/drive",
  },
  {
    key: "tour",
    label: { JP: "ツアー", EN: "Tours", 中文: "行程", 한국어: "투어" },
    icon: "🏄",
    path: "/blog/category/tour",
  },
  {
    key: "gourmet",
    label: { JP: "グルメ", EN: "Food", 中文: "美食", 한국어: "맛집" },
    icon: "🍴",
    path: "/blog/category/gourmet",
  },
];

export const tags = [
  "#宮古島",
  "#撮影",
  "#ドローン",
  "#SUP",
  "#映えスポット",
  "#ビーチ",
  "#サンセット",
  "#カフェ巡り",
  "#宮古島スイーツ",
  "#雨の日",
  "#室内体験",
  "#宮古島体験",
  "#旅動画",
  "#映え",
  "#ショート動画",
];

export const tagLinks = tags.map((tag) => ({
  label: tag,
  key: tag.replace("#", ""),
  path: `/blog/tag/${encodeURIComponent(tag.replace("#", ""))}`,
}));

export const shareLinks = [
  {
    label: "LINE",
    type: "line",
  },
];

export const sidebarTourCard = {
  title: {
    JP: "空から見る宮古島",
    EN: "Miyakojima from the Sky",
    中文: "从空中看宫古岛",
    한국어: "하늘에서 보는 미야코지마",
  },
  text: {
    JP: "ドローン撮影付きの特別なツアーを体験しませんか？",
    EN: "Try a special tour with drone shooting included.",
    中文: "体验包含无人机拍摄的特别行程。",
    한국어: "드론 촬영이 포함된 특별한 투어를 경험해보세요.",
  },
  buttonText: {
    JP: "ツアーを予約する",
    EN: "Book a Tour",
    中文: "预约行程",
    한국어: "투어 예약하기",
  },
  path: "/tours",
  image: "v1785121480/DJI_20260715152255_0050_D_qy3eue.webp",
};

export const articleCta = {
  title: "思い出を一生残る形に",
  text: "宮古島での特別な思い出を写真や映像で残します",
  buttonText: "撮影付きツアーを見る",
  path: "/tours/one-day-photogenic-tour",
};
